import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Wrapper = styled.div``;

const Card = styled.div`
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  width: 100%;
  max-height: 600px;
  overflow: hidden;

  @media (max-width: 650px) {
    max-height: fit-content;
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
`;

const Info = styled.div`
  width: calc(100% - 40%);
  margin: auto;
  padding: 16px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
  transform: translateY(0);
  transition: transform 0.4s ease;

  ${Card}:hover & {
    transform: translateY(-50px);
  }
`;

const Material = styled.div`
  font-size: ${fontSize.xxs};
  color: ${colors.primaryGray};
`;

const Category = styled.span`
  font-size: ${fontSize.s};
  letter-spacing: 0.12rem;
  text-transform: uppercase;
`;

const Discover = styled.span`
  font-size: ${fontSize.xxs};
  color: ${colors.maroon};
`;

function CategoryCard({ category, img, onClick }) {
  return (
    <Wrapper onClick={onClick}>
      <Card>
        <ImageWrapper>
          <Image src={img} alt="category image" />
        </ImageWrapper>
        <Info>
          <Material>LANGTANG 2025</Material>
          <Category>{category}</Category>
          <Discover>DISCOVER MORE</Discover>
        </Info>
      </Card>
    </Wrapper>
  );
}

export default CategoryCard;
